import React, { FC } from 'react'

import { css, cx } from '@linaria/core'

import { breakpoints } from 'components/designSystem/shared/breakpoints'

const commonCss = css`
  display: flex;
  justify-content: center;
  max-width: 30vw;
  object-fit: contain;

  @media (max-width: ${breakpoints.mobile - 1}px) {
    max-width: 90%;
  }
`

export const Picture: FC<{
  webp?: {
    src: string
  }
  png?: {
    src: string
  }
}> = ({ webp, png }) => {
  return (
    <picture className={cx(commonCss)}>
      {webp && <source src={webp.src} type="image/webp" />}
      {png && <source src={png.src} type="image/png" />}
      <img className={cx(commonCss)} src={png?.src} loading="lazy" />
    </picture>
  )
}
